import api from "../api";
import {commit} from "lodash/seq";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        all_tps: {data: [], current_page: 1, total: 0, per_page: 10},
        tps_details: {data: [], current_page: 1, total: 0, per_page: 10},
        arrears: {},
        tps: {
            tenancy: {
                property: {
                    images: [],
                    price: '',
                    project: {
                        name: '',
                        county: {
                            name: ''
                        },
                        charges: []
                    },
                    property_typology: {
                        name: ''
                    }
                },
                property_unit: {
                    name: ''
                },
                tenant: {
                    full_name: '',
                    country: {
                        name: ''
                    }
                },
                payment_mode: {
                    name: ''
                }
            }
        },
        loading: false,
        errors: {
            data: {
                errors: {
                    amount: [],
                    rate: [],
                    tenancy_id: [],
                    date: []
                }
            }
        },
        has_errors: false,
    },
    getters: {
        loading: state => state.loading,
        dialogVisible: state => state.dialogVisible,
        all_tps: state => state.all_tps,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        tps: state => state.tps,
        arrears: state => state.arrears,
        tps_details: state => state.tps_details
    },
    mutations: {
        setArrears(state, data) {
            state.arrears = data
        },
        setLoading(state, val) {
            state.loading = val
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setTps(state, data) {
            state.tps = data;
        },
        setTpsDetails(state, data) {
            state.tps_details = data;
        },
        setAllTps(state, data) {
            state.all_tps = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            amount: [],
                            rate: [],
                            tenancy_id: [],
                            date: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        async openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async getAllTps({commit}, filters) {
            try {
                commit('activateLoading', 'tps/list', {root: true});
                const response = await api.getAllTps(filters);
                commit('setAllTps', response);
                commit('deactivateLoading', 'tps/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async getArrearsAndDelayedPayments({commit}, filters) {
            try {
                commit('activateLoading', 'tps/list', {root: true});
                const response = await api.getArrearsAndDelayedPayments(filters);
                commit('setArrears', response.data);
                commit('deactivateLoading', 'tps/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getTps({commit}, id) {
            try {
                commit('activateLoading', 'tps/list', {root: true});
                const response = await api.getTps(id);
                commit('setTps', response.data);
                commit('deactivateLoading', 'tps/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getTpsDetails({commit}, filters) {
            try {
                commit('activateLoading', 'tps/list', {root: true});
                const response = await api.getTpsDetails(filters);
                commit('setTpsDetails', response);
                commit('deactivateLoading', 'tps/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async createTps({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.createTps(data);
                dispatch('getAllTps', {
                    paginate: true
                })
                commit('setLoading', false)
                ElMessage.success('Tps created successfully!');
                location.href = '/admin/tps/tps'
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response.status === 422 ? e.response : {
                    data: {
                        errors: {
                            amount: [],
                            rate: [],
                            tenancy_id: [],
                            date: []
                        }
                    }
                })
                ElMessage.error(e.response.data.message);
            }
        },
        async editTps({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                await api.editTps(data);
                dispatch('getAllTps', {
                    paginate: true
                });
                commit('hasErrors', false)
                ElMessage.success('Information updated successfully.');
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },

        async deleteTps({dispatch}, data) {
            try {
                await api.deleteTps(data);
                dispatch('getAllTps', {
                    paginate: true
                })
                ElMessage.success("Tps removed successfully.")
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error(e.response.data.message)
                } else {
                    ElMessage.error('Error deleting Tps');
                }
            }
        },
        async exportTpsStatement({commit}, tpsId) {
            commit('setLoading', true)
            try {
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.downloadTenancyReport(tpsId);
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Tenancy_Statement_Report' + fileName + '.pdf');
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                commit('deactivateLoading', 'entity/list', {root: true});
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },
        async sendTpsStatement({commit}, tpsId) {
            commit('setLoading', true)
            try {
                const response = await api.sendTenancyReport(tpsId);
                ElMessage.success(response?.message || "Statement emailed successfully.");
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                if (e.response?.status === 422) {
                    ElMessage.error(e.response.data.message);
                } else {
                    ElMessage.error(e.response?.data?.message || 'Error sending statement.');
                }
            }
        }
    }
}
